import { clone } from '@jack-henry/frontend-utils/functions';
import { RateQuoteModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export const nullWireQuote: RateQuoteModelDto = {
    id: 0,
    updatedDate: '',
    amexContractNumber: '',
    amexQuoteId: undefined,
    originAmount: 0,
    destinationAmount: 0,
    destinationCurrencyCode: '',
    valueDate: '',
    wireFee: 0,
    exchangeFee: 0,
    totalCost: 0,
    expirationTime: 0,
    conversionRate: 0,
};

export class WireQuote extends DomainEntity<RateQuoteModelDto> {
    constructor(dto = clone(nullWireQuote)) {
        super(dto);
    }

    public createDefault(): this {
        return new WireQuote(clone(nullWireQuote)) as this;
    }

    public get amexContractNumber() {
        return this.dto.amexContractNumber;
    }

    public get amexQuoteId() {
        return this.dto.amexQuoteId;
    }

    public get originAmount() {
        return this.dto.originAmount;
    }

    public get destinationAmount() {
        return this.dto.destinationAmount;
    }

    public get destinationCurrencyCode() {
        return this.dto.destinationCurrencyCode;
    }

    public get valueDate() {
        return this.dto.valueDate;
    }

    public get wireFee() {
        return this.dto.wireFee;
    }

    public get exchangeFee() {
        return this.dto.exchangeFee;
    }

    public get totalCost() {
        return this.dto.totalCost;
    }

    public get expirationTime() {
        return this.dto.expirationTime;
    }

    public get conversionRate() {
        return this.dto.conversionRate;
    }
}
